import { SelectOption } from "@/types/inputField"
import { ColumnDef } from "@tanstack/react-table"

export const columns: ColumnDef<SelectOption>[] = [
  {
    accessorKey: 'checkbox',
    header: '',
  },
  {
    accessorKey: 'value',
    header: ''
  }
]
